[
  {
    "id": "TB-E7P-001",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Tik op het stuk tekst waar 'hierdoor' naar verwijst.",
    "options": ["De bomen staan zo dicht op elkaar dat er nauwelijks wind doorheen komt"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "In Japan bestaat een bos genaamd Aokigahara. Het staat bekend als een van de stilste plekken op aarde. ", "id": "s1", "isTappable": false },
        { "text": "De bomen staan zo dicht op elkaar dat er nauwelijks wind doorheen komt", "id": "s2", "isCorrect": true },
        { "text": ". ", "id": "s3", "isTappable": false },
        { "text": "Hierdoor", "id": "s4", "isHighlighted": true, "isTappable": false },
        { "text": " is het er ", "id": "s5", "isTappable": false },
        { "text": "doodstil", "id": "s6" },
        { "text": ".", "id": "s7", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "Goed! 'Hierdoor' verwijst naar de oorzaak: de bomen staan zo dicht dat er geen wind doorheen komt.",
        "s6": "Doodstil is het gevolg, niet de oorzaak."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-AOKIGAHARA",
    "explanation": "'Hierdoor' verwijst naar de oorzaak in de vorige zin: de bomen staan zo dicht dat er geen wind doorheen komt. Dat is de reden voor de stilte.",
    "distractorExplanations": {
      "5": "Doodstil is het gevolg, niet de oorzaak."
    }
  },
  {
    "id": "TB-E7P-002",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Lees de tekst:\n\n\"Vaccins zijn een van de belangrijkste medische uitvindingen ooit. Dankzij vaccins zijn ziektes als pokken volledig verdwenen. Toch weigeren sommige ouders hun kinderen te laten vaccineren. Artsen waarschuwen dat dit gevaarlijk kan zijn.\"\n\nWat betekent het woord 'preventief' als een arts zegt: 'Vaccineren is een preventieve maatregel.'",
    "options": ["Bedoeld om ziekte te voorkomen", "Bedoeld om ziekte te genezen", "Bedoeld om ziekte te onderzoeken", "Bedoeld om ziekte te verspreiden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-PREVENTIEF",
    "explanation": "'Preventief' betekent voorkomend — je doet iets om te voorkomen dat er een probleem ontstaat. Vaccineren voorkomt ziekte.",
    "distractorExplanations": {
      "1": "Genezen is 'curatief', niet preventief.",
      "2": "Onderzoeken is 'diagnostisch'.",
      "3": "Verspreiden is het tegenovergestelde van wat vaccins doen."
    }
  },
  {
    "id": "TB-E7P-003",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Lees de twee teksten:\n\nTekst A: \"Huisdieren zijn goed voor kinderen. Ze leren verantwoordelijkheid en empathie.\"\n\nTekst B: \"Uit onderzoek van de Universiteit Leiden blijkt dat kinderen met huisdieren 15% minder stresshormonen hebben.\"\n\nWelke tekst is subjectief en welke objectief?",
    "options": ["Tekst A is subjectief, tekst B is objectief", "Tekst A is objectief, tekst B is subjectief", "Beide zijn subjectief", "Beide zijn objectief"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "feit_mening",
    "familyId": "TB-SUBJECTIEF-OBJECTIEF",
    "explanation": "Tekst A geeft een mening ('zijn goed') zonder bewijs — subjectief. Tekst B verwijst naar onderzoek met cijfers — objectief.",
    "distractorExplanations": {
      "1": "Het is andersom: A is mening, B is feit.",
      "2": "Tekst B is objectief door het onderzoek en de cijfers.",
      "3": "Tekst A mist bewijs en is daarom subjectief."
    }
  },
  {
    "id": "TB-E7P-004",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Tik op het signaalwoord dat een tegenstelling aangeeft.",
    "options": ["Echter"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "De uitvinding van het internet heeft de wereld ingrijpend veranderd. Informatie is ", "id": "s1", "isTappable": false },
        { "text": "nu", "id": "s2" },
        { "text": " voor iedereen beschikbaar. ", "id": "s3", "isTappable": false },
        { "text": "Echter", "id": "s4", "isCorrect": true },
        { "text": ", niet alle informatie op internet is betrouwbaar. Het is ", "id": "s5", "isTappable": false },
        { "text": "daarom", "id": "s6" },
        { "text": " belangrijk om bronnen te controleren.", "id": "s7", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "'Nu' geeft tijd aan, geen tegenstelling.",
        "s4": "Goed! 'Echter' geeft een tegenstelling aan: informatie is beschikbaar, MAAR niet alles is betrouwbaar.",
        "s6": "'Daarom' geeft oorzaak-gevolg aan, geen tegenstelling."
      }
    },
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-ECHTER",
    "explanation": "'Echter' geeft een tegenstelling aan: informatie is beschikbaar, MAAR niet alles is betrouwbaar.",
    "distractorExplanations": {
      "1": "'Nu' geeft tijd aan.",
      "5": "'Daarom' geeft oorzaak-gevolg aan."
    }
  },
  {
    "id": "TB-E7P-005",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Tik op het stuk tekst waar 'daarvan' naar verwijst.",
    "options": ["miljoenen diersoorten"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "De Amazone-rivier", "id": "s1" },
        { "text": " is de langste rivier ter wereld. In ", "id": "s2", "isTappable": false },
        { "text": "het regenwoud", "id": "s3" },
        { "text": " eromheen leven ", "id": "s4", "isTappable": false },
        { "text": "miljoenen diersoorten", "id": "s5", "isCorrect": true },
        { "text": ". Veel ", "id": "s6", "isTappable": false },
        { "text": "daarvan", "id": "s7", "isHighlighted": true, "isTappable": false },
        { "text": " zijn nog niet eens ontdekt. ", "id": "s8", "isTappable": false },
        { "text": "Wetenschappers", "id": "s9" },
        { "text": " schatten dat er nog duizenden onbekende soorten zijn.", "id": "s10", "isTappable": false }
      ],
      "feedbackMap": {
        "s1": "De rivier wordt niet ontdekt of niet ontdekt.",
        "s3": "Het regenwoud is al bekend.",
        "s5": "Goed! 'Veel daarvan' verwijst naar 'miljoenen diersoorten'. Veel van die soorten zijn nog niet ontdekt.",
        "s9": "Wetenschappers worden niet ontdekt."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-AMAZONE",
    "explanation": "'Veel daarvan' verwijst naar 'miljoenen diersoorten' uit de vorige zin. Veel van die diersoorten zijn nog niet ontdekt.",
    "distractorExplanations": {
      "0": "De rivier wordt niet ontdekt.",
      "2": "Het regenwoud is al bekend.",
      "8": "Wetenschappers worden niet ontdekt."
    }
  },
  {
    "id": "TB-E7P-006",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Lees de tekst:\n\n\"Elke seconde worden er 6.000 tweets verstuurd. Per dag zijn dat meer dan 500 miljoen berichten. Critici zeggen dat dit leidt tot oppervlakkig denken. Voorstanders beweren juist dat het de democratie versterkt.\"\n\nWat is de tekststructuur?",
    "options": ["Feiten gevolgd door twee tegengestelde meningen", "Alleen feiten", "Alleen meningen", "Een probleem met een oplossing"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "tekststructuur",
    "familyId": "TB-STRUCTUUR-TWITTER",
    "explanation": "De eerste twee zinnen zijn feiten (cijfers). Daarna volgen twee tegengestelde meningen: critici vs. voorstanders.",
    "distractorExplanations": {
      "1": "De laatste twee zinnen zijn meningen.",
      "2": "De eerste twee zinnen zijn feiten.",
      "3": "Er wordt geen oplossing geboden."
    }
  },
  {
    "id": "TB-E7P-007",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Wat betekent het woord 'subjectief' in de zin: 'Dat is een subjectieve mening.'",
    "options": ["Gebaseerd op persoonlijke gevoelens, niet op feiten", "Gebaseerd op feiten en onderzoek", "Heel belangrijk", "Heel moeilijk"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-SUBJECTIEF",
    "explanation": "'Subjectief' betekent vanuit je eigen gevoel of mening, niet gebaseerd op feiten. Het tegenovergestelde is 'objectief'.",
    "distractorExplanations": {
      "1": "Dat is 'objectief'.",
      "2": "Subjectief gaat niet over belang.",
      "3": "Subjectief gaat niet over moeilijkheid."
    }
  },
  {
    "id": "TB-E7P-008",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Tik op het signaalwoord dat een opsomming aangeeft.",
    "options": ["Niet alleen... maar ook"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "De gemiddelde Nederlander gooit ", "id": "s1", "isTappable": false },
        { "text": "jaarlijks", "id": "s2" },
        { "text": " 150 kilo voedsel weg. Dit is ", "id": "s3", "isTappable": false },
        { "text": "niet alleen", "id": "s4", "isCorrect": true },
        { "text": " zonde van het geld, ", "id": "s5", "isTappable": false },
        { "text": "maar ook", "id": "s6", "isCorrect": true },
        { "text": " slecht voor het milieu. Bij de productie van voedsel komt ", "id": "s7", "isTappable": false },
        { "text": "namelijk", "id": "s8" },
        { "text": " veel CO₂ vrij.", "id": "s9", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "'Jaarlijks' geeft tijd aan, geen opsomming.",
        "s4": "Goed! 'Niet alleen... maar ook' somt twee nadelen op: zonde van geld EN slecht voor het milieu.",
        "s6": "Goed! 'Niet alleen... maar ook' somt twee nadelen op.",
        "s8": "'Namelijk' geeft een verklaring, geen opsomming."
      }
    },
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-NIETALLENMAAROOK",
    "explanation": "'Niet alleen... maar ook' somt twee nadelen op: zonde van geld EN slecht voor het milieu.",
    "distractorExplanations": {
      "1": "'Jaarlijks' geeft tijd aan.",
      "7": "'Namelijk' geeft een verklaring."
    }
  },
  {
    "id": "TB-E7P-009",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Lees de tekst:\n\n\"Marie Curie was de eerste vrouw die een Nobelprijs won. Ze ontdekte twee nieuwe elementen: polonium en radium. Haar onderzoek was baanbrekend, maar ook gevaarlijk. Ze werd uiteindelijk ziek door de straling.\"\n\nWat is de beste samenvatting?",
    "options": ["Marie Curie deed baanbrekend maar gevaarlijk onderzoek naar straling", "Marie Curie won een prijs", "Straling is gevaarlijk", "Polonium en radium zijn elementen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "samenvatten",
    "familyId": "TB-SAMENVATTEN-CURIE",
    "explanation": "De tekst beschrijft Curies baanbrekende werk en de gevaarlijke gevolgen. De samenvatting vangt beide elementen.",
    "distractorExplanations": {
      "1": "Te beperkt — mist het onderzoek en de gevolgen.",
      "2": "Te algemeen — de tekst gaat specifiek over Curie.",
      "3": "Een detail, niet de kern van de tekst."
    }
  },
  {
    "id": "TB-E7P-010",
    "module": "Taalbegrip",
    "difficulty": 206,
    "question": "Lees de tekst:\n\n\"Steeds meer steden verbieden auto's in het centrum. Parijs, Oslo en Madrid hebben al autovrije zones. De luchtkwaliteit verbetert er aantoonbaar. Tegenstanders vrezen echter dat winkels klanten verliezen.\"\n\nWelke conclusie kun je trekken?",
    "options": ["Autovrije zones hebben voordelen (schonere lucht) maar ook mogelijke nadelen (minder klanten)", "Autovrije zones zijn alleen maar goed", "Autovrije zones zijn alleen maar slecht", "Alle steden verbieden auto's"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-CONCLUSIE-AUTOVRIJ",
    "explanation": "De tekst presenteert een voordeel (luchtkwaliteit) en een mogelijk nadeel (klantenverlies). De conclusie is genuanceerd.",
    "distractorExplanations": {
      "1": "Er worden ook nadelen genoemd.",
      "2": "Er worden ook voordelen genoemd.",
      "3": "Er staat 'steeds meer', niet 'alle'."
    }
  }
]